/*!
 * [Betbuilder Aggregator API] API Module
 * Modul pre API komunikáciu s BetBuilder Aggregator backend
 */

betbuilderAgg.api = {

    // Generická funkcia pre API volania
    apiRequest: function(options) {
        options = options || {
            endpoint: "",
            method: "GET",
            data: null,
            onSuccess: null,
            onError: null
        };
        try {
            var requestUrl = url.betbuilderAgg + "platform/" + offer.platform + "/" + options.endpoint;
            var fetchOptions = {
                method: options.method || "GET",
                headers: {
                    "Authorization": "Bearer " + (stored.Token || ""),
                    "Content-Type": "application/json"
                }
            };

            // Ak je metoda POST a sú dáta, pridáme ich do tela požiadavku
            if (options.data && options.method === "POST") {
                fetchOptions.body = JSON.stringify(options.data);
            }

            fetch(requestUrl, fetchOptions)
                .then(function(response) {
                    // Pre HTTP error status kódy (4xx, 5xx) skúsime parsovať JSON
                    // API môže vrátiť štruktúrovanú chybu s ErrorCode/ErrorKey
                    if (!response.ok) {
                        return response.json().then(function(errorData) {
                            // Ak response obsahuje ErrorCode alebo ErrorKey, pošleme to do onSuccess
                            // aby sa to tam ošetrilo ako business error
                            if (errorData && (errorData.ErrorCode || errorData.ErrorKey)) {
                                return errorData;
                            }
                            // Inak to je HTTP error
                            throw new Error("HTTP error " + response.status);
                        }).catch(function(parseError) {
                            // Ak parsovanie zlyhá, hoď HTTP error
                            throw new Error("HTTP error " + response.status);
                        });
                    }
                    return response.json();
                })
                .then(function(response) {
                    if (options.onSuccess) options.onSuccess(response);
                })
                .catch(function(error) {
                    if (options.onError) options.onError(error);
                    console.error("ERROR in BetBuilder API request:", error);
                });

        } catch (error) {
            console.error("BetBuilder API: Chyba pri volani API.", error);
            if (options.onError) options.onError(error);
        }
    },

    // Načítanie dostupných oddov pre event
    loadAvailableOdds: function(eventID, callbacks) {
        callbacks = callbacks || {};
        
        betbuilderAgg.api.apiRequest({
            endpoint: "available-odds/" + eventID,
            method: "GET",
            onSuccess: callbacks.onSuccess,
            onError: callbacks.onError
        });
    },

    // Výpočet konfliktných oddov
    calculateFilterOdds: function(oddsIDs, callbacks) {
        callbacks = callbacks || {};
        
        betbuilderAgg.api.apiRequest({
            endpoint: "calculate-filter-odds",
            method: "POST",
            data: { OddsIDs: oddsIDs },
            onSuccess: callbacks.onSuccess,
            onError: callbacks.onError
        });
    },

    // Vytvorenie MultiOdd
    createMultiOdd: function(oddsIDs, callbacks) {
        callbacks = callbacks || {};
        
        betbuilderAgg.api.apiRequest({
            endpoint: "multi-odd",
            method: "POST",
            data: { OddsIDs: oddsIDs },
            onSuccess: callbacks.onSuccess,
            onError: callbacks.onError
        });
    }

};
